import React from 'react'
import { string } from 'prop-types'

import Tabs from 'Pods/Shared/Tabs/Tabs'

import UserLogin from './Login'
import UserRegister from './Register'

function UserTabs({
  activeTabId = '', customId = '', source = '', captchaId = '',
}) {
  return (
    <Tabs
      key={activeTabId}
      tabs={[
        { title: 'Log in', id: 'login', contents: <UserLogin customId={customId} captchaId={captchaId} /> },
        { title: 'Register', id: 'register', contents: <UserRegister customId={customId} source={source} /> },
      ]}
      activeTabId={activeTabId || ''}
    />
  )
}

UserTabs.propTypes = {
  activeTabId: string,
  customId: string,
  source: string,
  captchaId: string,
}

export default UserTabs
